import script from "./LingoBadgeComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LingoBadgeComponent.vue?vue&type=script&lang=ts&setup=true"

import "./LingoBadgeComponent.vue?vue&type=style&index=0&id=781f3f66&lang=css"
import "./LingoBadgeComponent.vue?vue&type=style&index=1&id=781f3f66&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781f3f66"]])

export default __exports__